import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import {
  toggleSelectionFeatureInfo, toggleSelectionWindow, toggleBathroomVisualizerOpen
} from "../../../actions/actionFunctions";
import {useChangeWizardStepRoute} from "../materialsWizard/useChangeWizardStepRoute";

const MaterialsFooterBackButton = (props) => {

  const {cameFromPage, selectionFeatureInfo, showAdvancedQuoting, toggleSelectionWindow, toggleBathroomVisualizerOpen,
    selectionGroup, toggleSelectionFeatureInfo, history, wizardActiveStep, checkForSubStepChange, subStepChange,
    isWizard} = props;

  const {changeWizardStepRoute} = useChangeWizardStepRoute();

  const handleBackButtonClick = () => {
    if (cameFromPage === "visualizer") {
      toggleSelectionWindow(false, selectionGroup);
      toggleBathroomVisualizerOpen(true);
      history.push('/visualizer');
      return;
    } else if (selectionFeatureInfo) {
      toggleSelectionFeatureInfo(null);
      if (cameFromPage === "shoppingcart") {
        history.push("/shoppingcart");
      }
      return;
    } else if (showAdvancedQuoting) {
      history.push("/shoppingcart");
      return;
    } else if (checkForSubStepChange && subStepChange && !checkForSubStepChange("back")) {
      subStepChange();
      return;
    }
    if (isWizard) {
      changeWizardStepRoute(wizardActiveStep - 1);
    }
  }

  return (
    <button className="selection-footer-buttons__button selection-footer-buttons__button--prev"
            onClick={handleBackButtonClick}>
      <FormattedMessage id="quotingTool.footer.backButton"/>
    </button>
  )

};

MaterialsFooterBackButton.propTypes = {
  isWizard: PropTypes.bool,
  checkForSubStepChange: PropTypes.func,
  subStepChange: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {selectionGroup, selectionFeatureInfo} = store.selectionState;
  const {cameFromPage} = store.cartState;
  const {wizardActiveStep} = store.wizardState;
  const {showAdvancedQuoting} = store.advancedQuotingState;

  return {
    selectionGroup,
    selectionFeatureInfo,
    cameFromPage,
    wizardActiveStep,
    showAdvancedQuoting,
  };
};

const mapDispatchToProps = {
  toggleSelectionWindow,
  toggleBathroomVisualizerOpen,
  toggleSelectionFeatureInfo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MaterialsFooterBackButton)
)
